export const ROLLOUTS = {
    MEERKATS_VERTICAL_PAGE_CATEGORY_BUILDER: 'meerkats_vertical_page_category_builder',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
} as const;
